import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import { CLINIC } from "@/lib/data";

export const BookContext = React.createContext({ open: () => {} });

export default function Layout() {
  // "Book Appointment" now dials the centre's landline directly
  const openDialer = () => {
    const target = `tel:${CLINIC.altPhone.replace(/\s|-/g, "")}`;
    window.location.href = target;
  };

  return (
    <BookContext.Provider value={{ open: openDialer }}>
      <div className="App min-h-screen flex flex-col">
        <Header onBookClick={openDialer} />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <FloatingActions onBookClick={openDialer} />
      </div>
    </BookContext.Provider>
  );
}

